<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span><span class="sm">SOPHISTRY</span> <span class="sm">AND</span> <span class="sm">POLITICAL</span> <span class="sm">PHILOSOPHY</span></h1>
<h1 class="bk1">Protagoras’ Challenge to Socrates</h1>
<p class="bkau"><span class="page" data-locator="piii"></span><span class="sm">ROBERT</span> <span class="sm">C.</span> <span class="sm">BARTLETT</span></p>
<p class="bkpub"><span class="sm">THE</span> <span class="sm">UNIVERSITY</span> <span class="sm">OF</span> <span class="sm">CHICAGO</span> <span class="sm">PRESS</span></p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm">AND</span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Bartlett-SOPHISTRY-pbk-update-0003.vue?3a7de6c1